import React, { useState, useEffect } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment/moment";
import { FaRegEye } from "react-icons/fa6";
import { AiOutlinePrinter } from "react-icons/ai";
import { clearRows } from "../../../Redux/actions/rowActions";
import { useDispatch, useSelector } from "react-redux";
import "../pagination/pagination.css";
import { IoAddSharp } from "react-icons/io5";
import Pagination from "../pagination/pagination";
import { GrEdit } from "react-icons/gr";
import { MdOutlineDeleteOutline, MdOutlineAutorenew } from "react-icons/md";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { getName, getUserName } from "../../../Redux/selecters";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AddLeaseAgrement from './addLease';
import LeaseAgreementRenew from './leaseRenew/leaseRenew';
import AddLeaseAgrementView from './leaseAggrementView';
import EditLeaseAgrement from './editLease/editLease';
import CheckboxSetFilter from '../gridFilter/checkboxSetFilter';
import { useTranslation } from 'react-i18next';

const REPORT_URL = process.env.REACT_APP_REPORTS_URL
const LeaseListing = () => {
  const { t } = useTranslation(['leaseAgreement', 'common']);
  const [rowData, setRowData] = useState([]);
  const [proprtyList, setProperty] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [loader, setloader] = useState(true);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedtem, setSelectedItem] = useState(null);
  const apiService = new LeaseApiService();
  const userName = useSelector(getName);
  const [FilterTab, setFilterTab] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [previewModal, setPreviewModal] = useState(false);
  const [renew, setRenewpopup] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showRenewModal, setShowRenewModal] = useState(false);
  const [renewLeaseData, setRenewLeaseData] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewLeaseData, setViewLeaseData] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editLeaseData, setEditLeaseData] = useState(null);
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const location = useLocation();
  const StatusFilter = [
    { value: "All", label: "All" },
    { value: "0", label: "Active" },
    { value: "1", label: "Renewed" },
    { value: "2", label: "Terminated" },
  ]
  const [formData, setFormData] = useState({
    email: "",
    Proprty: [{ label: "Select Property", value: "" }],
    Status: [{ label: "Active", value: "" }],
    Unit: [{ label: "Select Unit", value: "" }],
    LeaseNo: [{ label: "Select Lease No", value: "" }],
    from: "",
    to: "",
  })
  const formatDate = (date) => {
    return moment(date).format("DD-MMM-YYYY");
  }
  useEffect(() => {
    const storedPermissions =
      JSON.parse(localStorage.getItem("RoleAccess")) || [];
    const permissions = storedPermissions?.filter(
      (acc) => acc.formName === "Purchase Requisition"
    );
    setPermissions(permissions[0]);
  }, [])
  useEffect(() => {
    getItems();
  }, [])
  useEffect(() => {
    fetchDropdownData();
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setFullYear(today.getFullYear() - 5);
    const toDate = new Date(today);
    toDate.setFullYear(today.getFullYear() + 5);
    setFormData((prev) => ({
      ...prev,
      from: formatDate(fromDate),
      to: formatDate(toDate),
    }));
  }, [])
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("dropdownTypes", "LASerPropertyName");
      const res = await apiService.getApiParamater(
        "GET_PROPERT_DROP",
        `?${params.toString()}`
      );
      setProperty(res?.data?.dropdowns?.LASerPropertyName);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }
  const handleEdit = async () => {

    if (selectedRow?.leaseNo) {
      try {

        setloader(true);
        const validation = new URLSearchParams();
        validation.append("Action", "checkLeaseEditValidation");
        validation.append("RecordId", selectedRow?.recordId);
        ;
        const validRes = await apiService.getApiParamater(
          "GET_UNITNO_DATA",
          `?${validation.toString()}`
        );
        let valisdlist = validRes?.data?.result?.data;
        // const leasoNolist = validRes?.data?.result?.data?.find(item => !item.Invoices );
        if (
          validRes?.data?.result?.data?.Invoices === 0 &&
          validRes?.data?.result?.data?.Receipts === 0
        ) {
          setloader(false);
          setEditLeaseData(selectedRow);
          setShowEditModal(true);
        } else if (
          validRes?.data?.result?.data?.Invoices > 0 ||
          validRes?.data?.result?.data?.Receipts > 0
        ) {
          toast.warning(
            `Invoices OR Receipts are created for this lease Aggrement (${selectedRow?.leaseNo}) Cannot be Edited`
          );
        } else if (validRes?.data?.result?.data?.length === 0) {
          toast.warning("Please refresh the page");
        }
      } catch (error) {
        setloader(false);
        console.error("Error Save Data", error?.deleteRes?.data?.message);
      }
    }
  }
  const handleRenew = async () => {
    if (selectedRow?.leaseNo && selectedRow?.status === "Active") {
      try {
        const validation = new URLSearchParams();
        validation.append("Action", "checkAmountReceivedForLeaseRenew");
        validation.append("LeaseNo", selectedRow?.leaseNo);
        const validRes = await apiService.getApiParamater(
          "GET_UNITNO_DATA",
          `?${validation.toString()}`
        );
        let valisdlist = validRes?.data?.result?.data;
        const totalAmount = valisdlist?.reduce((sum, row) => sum + (row.Balance || 0), 0);
        if (totalAmount > 0) {
          setRenewpopup(true)
          setloader(true);
        } else {
          navigate(
            `/Property/Management/LeaseAgreement/renew/${selectedRow?.leaseNo}`,
            { state: selectedRow }
          )
        }
      } catch (error) {
        setloader(false);
        console.error("Error Save Data", error?.deleteRes?.data?.message);
      }

    } else {
      toast.warning(t('leaseAgreement:cannotRenew'))
    }
  }
  const handleRenewshift = () => {
    if (selectedRow?.leaseNo && selectedRow?.status === "Active") {
      setRenewLeaseData(selectedRow);
      setShowRenewModal(true);
    } else {
      toast.warning(t('leaseAgreement:cannotRenew'))
    }
  }
  const handlePrint = () => {
    if (selectedRow?.leaseNo) {
      const token = localStorage.getItem("Token");
      const DB = localStorage.getItem("DataBase");
      if (!token) {
        alert("Auth token is missing! Unable to proceed.");
        return;
      }
      // const popupWidth = 1000;
      // const popupHeight = 600;
      // const popupLeft = (window.screen.width - popupWidth) / 2;
      // const popupTop = (window.screen.height - popupHeight) / 2;
      // const popup = window.open(
      //   "",
      //   "ReportPopup",
      //   `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
      // );
      const newTab = window.open("Lease_Residiential", "Lease_Residiential");
      if (newTab) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://procreports.apps.pro360erp.com/rdlreport/webform/DownloadDocPrints.aspx";
        form.target = "ReportPopup";

        const inputs = [
          { name: "authToken", value: token },
          { name: "_db", value: DB },
          { name: "reportName", value: "LeaseDocument" },
          { name: "LeaseNo", value: selectedRow?.leaseNo },
        ];
        inputs.forEach(({ name, value }) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
    }
  }
  const handleDelete = async () => {
    if (selectedRow?.leaseNo) {
      setloader(true);
      setPreviewModal(true);
    }
  }
  const handleDeleteLease = async () => {
    if (selectedRow?.leaseNo) {
      try {
        setloader(true);
        const validation = new URLSearchParams();
        validation.append("Action", "CheckLeaseDeleteValidation");
        validation.append("GroupId", selectedRow?.groupId);
        const validRes = await apiService.getApiParamater(
          "GET_UNITNO_DATA",
          `?${validation.toString()}`
        );
        let valisdlist = validRes?.data?.result?.data;
        // const leasoNolist = validRes?.data?.result?.data?.find(item => !item.Invoices );
        if (
          validRes?.data?.result?.data?.Invoices === 0 &&
          validRes?.data?.result?.data?.Receipts === 0
        ) {
          let body = {
            groupId: selectedRow?.groupId,
            modifiedBy: userName,
          };
          const deleteRes = await apiService.delete("DELETE_LEASE_AGRE", body);
          toast.success(`${selectedRow?.leaseNo} deleted Successfully`);
          getItems();
          setPreviewModal(false);
        } else if (
          validRes?.data?.result?.data?.Invoices > 0 ||
          validRes?.data?.result?.data?.Receipts > 0
        ) {
          toast.warning(
            `Invoices OR Receipts are created for this lease Aggrement (${selectedRow?.leaseNo}) Cannot be Deleted`
          );
          setPreviewModal(false);
        } else if (validRes?.data?.result?.data.length === 0) {
          setPreviewModal(false);
          toast.warning("Please refresh the page");
        } if (
          validRes?.data?.result?.data[0]?.Invoices === 0 &&
          validRes?.data?.result?.data[0]?.Receipts === 0
        ) {
          let body = {
            groupId: selectedRow?.groupId,
            modifiedBy: userName,
          };
          const deleteRes = await apiService.delete("DELETE_LEASE_AGRE", body);
          toast.success(`${selectedRow?.leaseNo} deleted Successfully`);
          getItems();
          setPreviewModal(false);
        }
      } catch (error) {
        setloader(false);
        setPreviewModal(false);
        console.error("Error Save Data", error?.deleteRes?.data?.message);
      }
    }
  }
  const handleEye = (clickedRowData) => {
    if (clickedRowData?.leaseNo) {
      const updatedData = {
        ...clickedRowData,
        eye: !clickedRowData.eye?.active,
      };
      setViewLeaseData(updatedData);
      setShowViewModal(true);
    } else if (selectedRow?.leaseNo) {
      const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
      setViewLeaseData(updatedData);
      setShowViewModal(true);
    }
  }
  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append("PageNo", newPageNo || 1);
      params.append("PageSize", pageSize || 20);
      params.append("PropertyName", formData?.Proprty?.label || "");
      params.append("Status", formData?.Status?.label || "Active");
      params.append("UnitNo", formData?.Unit?.label || "");
      params.append("FromDate", formData?.from || "");
      params.append("ToDate", formData?.to || "");
      const res = await apiService.getApiParamater(
        "GET_LEASE_AGRE",
        `?${params.toString()}`
      );

      setRowData(res?.data?.result || []);
      setPagination(res.data.paginationData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching items:", error);
      // Handle error (e.g., show error message to user)
      setLoading(false); // Set loading to false even in case of error
    }
  }
  const dateFormatter = (params) => {
    const date = moment(params.value);
    return date.format("DD-MMM-YYYY");
  }
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2)
      ? 0
      : momentDate1.isBefore(momentDate2)
        ? -1
        : 1;
  }
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      suppressMovable: true,
      width: 50,
      pinned: "left",
    },
    {
      headerName: t('leaseAgreement:columns.status'),
      field: "status",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 120,
      pinned: "left",
    },
    {
      headerName: t('leaseAgreement:columns.leaseNo'),
      field: "leaseNo",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 120,
      pinned: "left",
    },
    {
      headerName: t('leaseAgreement:columns.periodFrom'),
      field: "leaseStart",
      filter: CheckboxSetFilter,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: t('leaseAgreement:columns.periodTo'),
      field: "leaseEnd",
      filter: CheckboxSetFilter,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: t('leaseAgreement:columns.property'),
      field: "propertyName",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: t('leaseAgreement:columns.unitNum'),
      field: "unitNo",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: t('leaseAgreement:columns.unitType'),
      field: "unitType",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: t('leaseAgreement:columns.accountCode'),
      field: "tenantNo",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: t('leaseAgreement:columns.tenant'),
      field: "tenantName",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: t('leaseAgreement:columns.contactNum'),
      field: "contactNo",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.yearRent'),
      field: "yearRent",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.discount'),
      field: "discount",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.contractValue'),
      field: "total",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.rent'),
      field: "rent",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: t('leaseAgreement:columns.vat'),
      field: "vat",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.total'),
      field: "total",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: t('leaseAgreement:columns.tax'),
      field: "tax",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.bedRooms'),
      field: "tax1",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.area'),
      field: "totalArea",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: t('leaseAgreement:columns.installments'),
      field: "installments",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.invoicesGenerated'),
      field: "invoicesGenerated",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 150,
    },
    {
      headerName: t('leaseAgreement:columns.invoicesPending'),
      field: "invoicesPending",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 150,
    },
    {
      headerName: t('leaseAgreement:columns.remarks'),
      field: "remarks",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 180,
    },
    {
      headerName: t('leaseAgreement:columns.modified'),
      field: "modifiedBy",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.modifiedOn'),
      field: "modifiedOn",
      filter: CheckboxSetFilter,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: t('leaseAgreement:columns.createdBy'),
      field: "createdBy",
      filter: CheckboxSetFilter,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: t('leaseAgreement:columns.createdOn'),
      field: "createdOn",
      filter: CheckboxSetFilter,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
  ]
  const onSelectionChanged = async (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
  }
  const clearAllRows = () => {
    dispatch(clearRows());
  }
  const handlenew = () => {
    clearAllRows();
    setShowAddModal(true);
  }
  const handleClearFilters = () => {
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setFullYear(today.getFullYear() - 5);
    const toDate = new Date(today);
    toDate.setFullYear(today.getFullYear() + 5);
    setUnitList([]);
    setFormData({
      Proprty: [{ label: "Select Property", value: "" }],
      Unit: [{ label: "Select Unit", value: "" }],
      LeaseNo: [{ label: "Select Lease No", value: "" }],
      Status: [{ label: "Active", value: "" }],
      from: formatDate(fromDate),
      to: formatDate(toDate),
    });
    getItems();
  }
  const handlePropertyChange = async (selectedOption) => {
    setFormData((prev) => ({ ...prev, Proprty: selectedOption, Unit: [{ label: "Select Unit", value: "" }] }));
    try {
      const params = new URLSearchParams();
      params.append("DropdownFor", "LRAgreehUnitNosByPropertyId");
      params.append("CascadValue", selectedOption?.value);
      const res = await apiService.getApiParamater(
        "REPORT_CASCAD",
        `?${params.toString()}`
      );
      setUnitList(res?.data?.items || []);
    } catch (error) {
      console.error("Error fetching unit dropdown data:", error);
      setUnitList([]);
    }
  }
  const handleUnitChange = (selectedOption) => {
    setFormData({ ...formData, Unit: selectedOption });
  }
  const handleDateChange = (name, date) => {
    setFormData((prev) => ({ ...prev, [name]: date ? formatDate(date) : "" }));
  }
  const handleStatusFilter = (selectedOption) => {
    if (selectedOption.label == "All") {
      handleClearFilters();
    } else {
      setFormData({ ...formData, Status: selectedOption });
    }
  }
  return (
    <div className="p-3 ">
      <div className="cost-center-section">
        <div
          className="d-flex  cursor-pointer slide-header"
          onClick={() => setFilterTab(!FilterTab)}
        >
          <div className="h6 pt-1">{t('common:searchParameters')}</div>
        </div>
        <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
          <div
            className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
              }`}
          >
            <div className="filter-grid">
              <div className="filter-grid-fields">
                <div className="filter-grid-field">
                  <label>{t('common:property')}</label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                        color: state.isFocused ? "#000 " : "#000",
                        ":hover": {
                          backgroundColor: "#F5F5F5",
                          color: "#000 ",
                        },
                      }),
                    }}
                    value={formData.Proprty}
                    onChange={(selectedOption) =>
                      handlePropertyChange(selectedOption)
                    }
                    options={proprtyList?.map((rec) => ({
                      value: rec?.value,
                      label: rec?.text,
                    }))}
                  />
                </div>
                <div className="filter-grid-field">
                  <label>{t('common:status')}</label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                        color: state.isFocused ? "#000 " : "#000",
                        ":hover": {
                          backgroundColor: "#F5F5F5",
                          color: "#000 ",
                        },
                      }),
                    }}
                    value={formData.Status}
                    options={StatusFilter}
                    onChange={handleStatusFilter}
                  />
                </div>
                <div className="filter-grid-field">
                  <label>{t('common:unit')}</label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    isClearable
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                        color: state.isFocused ? "#000 " : "#000",
                        ":hover": {
                          backgroundColor: "#F5F5F5",
                          color: "#000 ",
                        },
                      }),
                    }}
                    placeholder={t('leaseAgreement:unitPlaceholder')}
                    value={formData.Unit}
                    onChange={handleUnitChange}
                    options={unitList?.map((rec) => ({
                      value: rec?.value,
                      label: rec?.text,
                    }))}
                  />
                </div>
                <div className="filter-grid-field">
                  <label>{t('common:from')}</label>
                  <DatePicker
                    selected={formData.from}
                    onChange={(date) => handleDateChange("from", date)}
                    dateFormat="dd-MMM-yyyy"
                    placeholderText={t('leaseAgreement:fromDatePlaceholder')}
                    className="p-2 form-control w-100"
                  />
                </div>
                <div className="filter-grid-field">
                  <label>{t('common:to')}</label>
                  <DatePicker
                    selected={formData.to}
                    onChange={(date) => handleDateChange("to", date)}
                    dateFormat="dd-MMM-yyyy"
                    placeholderText={t('leaseAgreement:toDatePlaceholder')}
                    className="p-2 form-control w-100"
                  />
                </div>
              </div>
              <div className="filter-grid-actions">
                <div
                  onClick={() => getItems()}
                  className="mainbtnGry flex-end gap-2"
                >
                  <FaFileCircleExclamation
                    color="#fff"
                    className="center mt-1 mx-2"
                  />
                  <div className="center">{t('common:search')}</div>
                </div>
                <div
                  onClick={() => handleClearFilters()}
                  className="mainbtnRed flex-end gap-2"
                >
                  <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                  <div className="center">{t('common:reset')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-box2 p-4">
        {loading ? (
          <div>{t('common:loading')}</div>
        ) : (
          <>
            <div className="d-flex justify-contant-between ">
              <h5 className="col mainInvHead">{t('leaseAgreement:listTitle')}</h5>
              <div className="d-flex justify-content-end gap-1">
                <div
                  onClick={handleEye}
                  className="mainbtnSecondary flex-end gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <FaRegEye color="#fff" className="center mt-1" />
                  <div className="center">{t('common:view')}</div>
                </div>
                {/* {permissions?.canUpdate === true ? */}
                <div
                  onClick={handleRenew}
                  className="mainbtnSecondary flex-end gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <MdOutlineAutorenew color="#fff" className="center mt-1 " />
                  <div className="center">{t('leaseAgreement:renew')}</div>
                </div>
                <div
                  onClick={handleEdit}
                  className="mainbtnSecondary flex-end gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <GrEdit color="#fff" className="center mt-1 " />
                  <div className="center">{t('common:edit')}</div>
                </div>
                <div
                  onClick={handleDelete}
                  className={`reversbtn flex-end gap-2 ${!selectedRow ? "" : "disabled"
                    }`}
                  style={{ cursor: selectedRow ? "pointer" : "not-allowed" }}
                >
                  <MdOutlineDeleteOutline
                    color="#fff"
                    className="center mt-1"
                  />
                  <div className="center">{t('common:delete')}</div>
                </div>
                {/* <div
                  onClick={handlePrint}
                  className={`mainbtnRed flex-end gap-2 ${!selectedRow ? "disabled" : ""
                    }`}
                  style={{ cursor: selectedRow ? "pointer" : "not-allowed" }}
                >
                  <AiOutlinePrinter color="#fff" className="center mt-1 " />
                  <div className="center">Print</div>
                </div> */}
                {/* {permissions?.canAdd === true ? */}
                <div className="col center">
                  <button
                    className="mainbtn "
                    type="submit"
                    onClick={() => handlenew()}
                  >
                    <IoAddSharp color="#fff" className="center mt-1" />{" "}
                    <div>{t('common:add')}</div>
                  </button>
                </div>
                {/* : '' */}
                {/* } */}
              </div>
            </div>
            <div className="gridshad  mt-3">
              <div className="ag-theme-quartz" style={{ height: 650 }}>
                <AgGridReact
                  getRowStyle={(params) => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: "#F0EDF5" };
                    } else {
                      return { background: "#fff" };
                    }
                  }}
                  rowData={rowData}
                  enableFilter={true}
                  columnDefs={columnDefs}
                  onSelectionChanged={onSelectionChanged}
                />
              </div>
              <Pagination
                pageSize={pageSize}
                setPageSize={setPageSize}
                pagination={pagination}
                getItems={getItems}
              />
            </div>
          </>
        )}
      </div>

      <Modal show={previewModal} size="md" onHide={() => setPreviewModal(false)}
        centered
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('leaseAgreement:deleteLeaseTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>{t('leaseAgreement:confirmDelete', { leaseNo: selectedRow?.leaseNo })}</Modal.Title>
        </Modal.Body>
        <Modal.Footer className='end p-3'>
          <button className="mainbtnRed" onClick={() => setPreviewModal(false)}>{t('common:cancel')}</button>
          <button className='mainbtn' onClick={handleDeleteLease}>{t('common:delete')}</button>
        </Modal.Footer>
      </Modal>
      <Modal show={renew} size="md" onHide={() => setRenewpopup(false)}
        centered
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('leaseAgreement:rentNotFullyReceived')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>{t('leaseAgreement:confirmProceed')}</Modal.Title>
        </Modal.Body>
        <Modal.Footer className='end p-3'>
          <button className="mainbtnRed" onClick={() => setRenewpopup(false)}>{t('common:no')}</button>
          <button className='mainbtn' onClick={handleRenewshift}>{t('common:yes')}</button>
        </Modal.Footer>
      </Modal>
      {showAddModal && (
        <AddLeaseAgrement
          show={showAddModal}
          onClose={() => setShowAddModal(false)}
          onSaved={() => {
            setShowAddModal(false);
            getItems();
          }}
        />
      )}
      {showRenewModal && (
        <LeaseAgreementRenew
          show={showRenewModal}
          leaseData={renewLeaseData}
          onClose={() => setShowRenewModal(false)}
          onSaved={() => {
            setShowRenewModal(false);
            getItems();
          }}
        />
      )}
      {showViewModal && (
        <AddLeaseAgrementView
          show={showViewModal}
          rowData={viewLeaseData}
          onClose={() => setShowViewModal(false)}
        />
      )}
      {showEditModal && (
        <EditLeaseAgrement
          show={showEditModal}
          rowData={editLeaseData}
          onClose={() => setShowEditModal(false)}
          onSaved={() => {
            setShowEditModal(false);
            getItems();
          }}
        />
      )}
    </div>
  );
};
export default LeaseListing;
